// Shared category metadata for the supplier directory.
import {
  Boat, Buildings, Car, Train, MapTrifold, ShieldCheck, Airplane, Package,
} from "@phosphor-icons/react";

export const SUPPLIER_CATEGORIES = [
  { value: "cruises",          label: "Cruises",          Icon: Boat },
  { value: "hotels",           label: "Hotels",           Icon: Buildings },
  { value: "car_rentals",      label: "Car Rentals",      Icon: Car },
  { value: "railways",         label: "Railways",         Icon: Train },
  { value: "tours",            label: "Tours",            Icon: MapTrifold },
  { value: "travel_insurance", label: "Travel Insurance", Icon: ShieldCheck },
  { value: "flights",          label: "Flights",          Icon: Airplane },
  { value: "packages",         label: "Packages",         Icon: Package },
];

export const CATEGORY_BY_VALUE = SUPPLIER_CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c;
  return acc;
}, {});
